import type { NLeads, NSmallGlobalEntities } from '@app/types';

export const defineAllIntegrationsExistence = (
  leads: NLeads.ModelLead[] | null,
  integrationsDictionary?: NSmallGlobalEntities.ModelItem[]
) => {
  const leadIntegrationIds: number[] = [];
  const handledLeads = leads || [];

  handledLeads.forEach(
    ({ SocialIntegrationId }) =>
      SocialIntegrationId && leadIntegrationIds.push(SocialIntegrationId)
  );

  const uniqueLeadIntegrations = leadIntegrationIds.reduce(
    (accumulator: Array<NSmallGlobalEntities.ModelItem['Id']>, current) => {
      if (
        !accumulator.find(
          (id: NSmallGlobalEntities.ModelItem['Id']) => id === current
        )
      ) {
        accumulator.push(current);
      }
      return accumulator;
    },
    []
  );

  const areUnknownTags = uniqueLeadIntegrations.some(
    (uniqueLeadTagId) =>
      !integrationsDictionary?.find(({ Id }) => Id === uniqueLeadTagId)
  );

  return !areUnknownTags;
};
